/**
 * Pure, platform-free fallback used until `configureThemeEnvironment` runs (or in a test
 * harness that never calls it) — resolves to light, with no persistence and no live
 * OS-preference following. Touches no browser global, so it's safe to define inside
 * `client/ui` itself (boundary rules B2/B3).
 */
const NOOP_THEME_ENVIRONMENT = {
    getStoredTheme: () => undefined,
    setStoredTheme: () => undefined,
    prefersDarkColorScheme: () => false,
    watchDarkColorScheme: () => undefined,
};
let activeThemeEnvironment = NOOP_THEME_ENVIRONMENT;
/**
 * Registers the real `ThemeEnvironmentPort` implementation. Mirrors
 * `skin/skin-stylesheet.ts`'s `applySkinStyleSheet` singleton — a module-level slot inside
 * `client/ui`, populated exactly once by the composition root (`system/pwa/src/main.ts`,
 * via `createBrowserThemeEnvironment()` from `@econ-v1/adapters-web`) before
 * `<node-app-shell>` is inserted into the document, so `shell/theme-init.ts`'s `initTheme`
 * reads the real environment the very first time it runs (before the shadow tree's first
 * paint — see that module's own doc comment for why this can't instead be threaded through
 * `@econ-v1/rpc`/the kernel). `client/ui` itself never references `localStorage` or
 * `matchMedia`; only the injected `env` does.
 */
export function configureThemeEnvironment(env) {
    activeThemeEnvironment = env;
}
/** Read by `theme-init.ts` as the default `env` argument — exported separately so tests can
 * pass a fake directly instead of mutating this module's shared singleton. */
export function currentThemeEnvironment() {
    return activeThemeEnvironment;
}
//# sourceMappingURL=theme-environment.js.map